module.exports = __webpack_public_path__ + "img/UI_common_framelabelDX_02_9ed4e64b3.png";